import React, {Component} from 'react';
import { Modal, NavBar, Toast} from "antd-mobile";
import {connect} from "react-redux";
import "./style.less"
import {getHistorInvoiceInfo,deleteHistorInvoiceInfo} from "../../service/invoiceService"
const notInvoice = require('../../common/image/notInvoice.png');
const dataError = require('../../common/image/dataError.png');

let pageSize = 30;
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class InvoiceHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notDataLoading:0,
            data: [
                // {id:0,name:"云南城投有限公司",num:"2987587469874328",},
                // {id:1,name:"云南城投有限公司",num:"2987587469874328",},
                // {id:2,name:"云南城投有限公司",num:"2987587469874328",},
            ],
        }
    }

    componentDidMount() {
        this.getData()
    }

    getData=()=>{
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1
            },
        };
        getHistorInvoiceInfo(params).then((res)=>{
            if(res.data.code == "0000"){
                if (res.data.data.list.length > 0) {
                    this.setState({data:res.data.data})
                }else{
                    this.setState({notDataLoading: 1,});
                }

            }else{
                Toast.info(res.data.msg);
                this.setState({notDataLoading: 2,});
            }
        })
    }
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noMore">
                {/*<img src={notInvoice} />*/}
                <p>暂无常用开票信息</p>
            </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noMore">
                {/*<img src={dataError} />*/}
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
    deleteInfo(res){
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data:{
                id:res.id
            },
        };
        deleteHistorInvoiceInfo(params).then((res)=>{
            if(res.data.code == "0000"){
                Toast.info("删除成功",3,this.getData)
            }else{
                Toast.info(res.data.msg);
            }
        })
    }
    render() {
        return (
            <Modal
                className="historyInfo"
                visible={this.props.historyInfoModal}
                onClose={this.props.onClose("historyInfoModal")}
                maskClosable={false}
            >
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={this.props.onClose("historyInfoModal")}/>}
                >常用开票信息</NavBar>
                {this.notData()}
                <div className="content">
                    {
                        this.state.data.list && this.state.data.list.map((res,index)=>(
                            <div className="list" key={index} onClick={()=>this.props.selInfo(res)}>
                                <div className="left">
                                    <p className="text">{res.invoiceUp}</p>
                                    <p><span>税号</span>{res.invoiceNumber}</p>
                                </div>
                                <i className="icon iconfont iconshanchu" onClick={(e)=>{
                                    e.stopPropagation();
                                    Modal.alert('是否确认删除此条记录？', <div >常用开票信息最多存30条信息</div>, [
                                        { text: '取消'},
                                        { text: '确定', onPress: () => this.deleteInfo(res)},
                                    ])
                                }}/>
                            </div>
                        ))
                    }
                </div>

            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/HistorInfo/index.js